import React from "react";
import { TouchableOpacity, GestureResponderEvent } from "react-native";
import { Icon } from "react-native-paper";
import { useNavigation } from "@react-navigation/native";
import queryClient from "../../../services/reactQuery";
import Colors from "../../../constants/Colors";

const BackButton: React.FC = () => {
  const navigation = useNavigation();

  const handlePress = async (_event?: GestureResponderEvent) => {
    await queryClient.invalidateQueries(["openHouses"]);
    navigation.goBack();
  };

  return (
    <TouchableOpacity
      onPress={handlePress}
      hitSlop={{ top: 50, bottom: 50, left: 50, right: 50 }}
    >
      <Icon
        source="arrow-left"
        size={24}
        color={Colors.primary_500} // Replace with your actual color if not using Colors.primary_500
      />
    </TouchableOpacity>
  );
};

export default BackButton;
